
import { default as Moment, default as moment } from 'moment';
import { DefaultDateFormat } from '../Component/Common/Constants/Dates';
import { isNullOrUndefined } from 'util';

export const dateString = "";

export const userFriendlyDate = (date: Date) => {

    if (!Moment(date).isValid()) return 'Unspecified';

    return Moment(date).format(DefaultDateFormat);
}

export const formatDate = (date: Date) => {
   
    let month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('/');
}

export const getDateAsString = (date: Date | undefined) => {
    if (isNullOrUndefined(date)){
        return ''
    }
    return moment(date).format("DD MMMM YYYY");
}

export const getDateAsDashSeparatedString = (date: Date | undefined) => {
    if (isNullOrUndefined(date)){
        return ''
    }
    return moment(date).format("DD-MM-YYYY");
}

export const getDaysUntilActivity = (days: number) => {
    if (days === 0) return 'today';
    return days === 1 ? '1 day' : `${days} days`;
}

export function getDateWithoutTime(date: Date) : Date {
    return new Date(date.setHours(0, 0, 0, 0));
} 